import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import MainLogo from '../assets/images/OP_IPSA_Main_Logo.svg'
import ArrowImage from '../assets/images/OP_Portal_Arrow_White_RT.svg'
import PoweredByImage from '../assets/images/OP_IPSA_PoweredBy_Logo.svg'
import IpsaSidebarContext from '../context/SidebarContext'

const IpsaSidebar = ({ children }) => {
    const { sidebarOpen, setSidebar } = useContext(IpsaSidebarContext)

    return (
        <div id="section-side" className={sidebarOpen ? null : 'side-closed'}>
            <img
                id="side-toggle"
                onClick={() => setSidebar(!sidebarOpen)}
                src={ArrowImage}
                alt="toggle sidebar"
            />

            <div id="section-side-content">
                <Link to="/clients">
                    <img id="ipsa-logo" src={MainLogo} alt="IPSA" />
                </Link>

                <div id="section-side-content">{children}</div>
            </div>
        </div>
    )
}
export default IpsaSidebar
